import responsiveSize from 'helper/responsiveSize'
import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IInputProps {
  empty?: boolean
  error?: string
  secondary?: boolean
  small?: boolean
}

export const Input = styled.input`
  display: black;
`

export const Label = styled.label`
  color: ${Theme.pallete.QUATERNARY2};
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: ${(props: IInputProps) => {
    if (props.small)
      return `${responsiveSize.responsiveWidth(
        Theme.sizes.BUTTONS.FONT.SECONDARY
      )}`
    return `${responsiveSize.responsiveWidth(
      Theme.sizes.BUTTONS.FONT.TERTIARY
    )}`
  }};
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const Div = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  gap: ${responsiveSize.responsiveWidth(Theme.sizes.BUTTONS.GAP.SECONDARY)};
  .radio-btn-container {
    display: flex;
    align-items: center;

    gap: ${responsiveSize.responsiveWidth(Theme.sizes.BUTTONS.GAP.TERTIARY)};
  }

  .radio-btn-icon {
    width: ${responsiveSize.responsiveWidth(Theme.sizes.BUTTONS.WIDTH.SENARY)};
    height: ${responsiveSize.responsiveHeight(
      Theme.sizes.BUTTONS.HEIGHT.TERTIARY
    )};
  }

  input[type='radio'] {
    -webkit-appearance: none;
    background-color: ${Theme.pallete.SECONDARY};
    border: 2px solid ${Theme.pallete.QUATERNARY2};
    padding: 2px;
    border-radius: 50%;
    width: ${responsiveSize.responsiveWidth(Theme.sizes.BUTTONS.WIDTH.SENARY)};
    height: ${responsiveSize.responsiveHeight(
      Theme.sizes.BUTTONS.HEIGHT.TERTIARY
    )};
  }
  input[type='radio']:checked {
    background-color: ${Theme.pallete.TERTIARY};
    border: 2px solid ${Theme.pallete.TERTIARY};

    width: ${responsiveSize.responsiveWidth(
      Theme.sizes.BUTTONS.WIDTH.SEPTENARY
    )};
    height: ${responsiveSize.responsiveHeight(
      Theme.sizes.BUTTONS.HEIGHT.QUATERNARY
    )};
  }

  .radio-button-checked {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid ${Theme.pallete.TERTIARY};
    border-radius: 50%;

    width: ${responsiveSize.responsiveWidth(Theme.sizes.BUTTONS.WIDTH.SENARY)};
    height: ${responsiveSize.responsiveHeight(
      Theme.sizes.BUTTONS.HEIGHT.TERTIARY
    )};
  }
`
